import { FC } from "react";
import useEvent from "react-use-event-hook";
import styled from "styled-components";

import { useModalConfirm } from "@ryde/redux";
import { ConfirmResult, IStyledAttributes } from "@ryde/shared";

import { ModalDialog } from "../controls";

const ConfirmationContentWrapper = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "confirmation-content-wrapper",
})`
  padding: 0;
`;
const ConfirmationContentStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "confirm-content",
})`
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 10px;
`;

export const ConfirmDialogHolder: FC = () => {
  const { open, modalOptions, handleResult } = useModalConfirm();
  const {
    title,
    message,
    customContent,
    okButtonTitle,
    cancelButtonTitle,
    showOkButton,
    showFooter,
    width,
    isOkButtonDisabled,
  } = modalOptions;

  const handleCloseModalClick = useEvent(() => {
    handleResult(ConfirmResult.CANCEL);
  });

  const handleCloseModalHeaderClick = useEvent(() => {
    handleResult(ConfirmResult.CANCEL_BY_HEADER);
  });

  const handleSaveClick = useEvent(() => {
    handleResult(ConfirmResult.OK);
  });

  return (
    <>
      {open && (
        <ModalDialog
          title={title}
          closeModalClick={handleCloseModalClick}
          closeModalHeaderClick={handleCloseModalHeaderClick}
          saveClick={handleSaveClick}
          isModalOpen={open}
          showContent={!!message}
          showFooter={showFooter}
          showOkButton={showOkButton}
          isSaveButtonDisabled={isOkButtonDisabled}
          saveButtonTitle={okButtonTitle}
          closeButtonTitle={cancelButtonTitle}
          width={width}
        >
          <ConfirmationContentWrapper>
            {message && (
              <ConfirmationContentStyled>{message}</ConfirmationContentStyled>
            )}
            {customContent}
          </ConfirmationContentWrapper>
        </ModalDialog>
      )}
    </>
  );
};
